import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {connectForm} from '../../core/redux/form'
import {connectLoadingLock} from '../../core/redux/loading'
import extract, {replace} from '../../core/extract'
import {mediaQuery} from '../../core/browser'
import Picker from '../../core/components/Picker'
import TypeaheadBar, {matcher} from '../../core/components/TypeaheadBar'
import Icon from '../../core/components/Icon'
import {Criteria} from '../models'
import {DEFAULT_PATRIMONY_QUERY, MINOR_CRITERIA_UPDATED, updateMinorCriteria, resetMinorCriteria, queryPatrimonyStream} from '../actions'
import i18n from '../i18n'
import style from './PatrimonyPicker.less'

function geoLocationCriteria(zipCode, placeId, geoLocation, action) {
    if (action) {
        // second attempt
        if (placeId && geoLocation && action.stream.length == 0) return {geoLocation}
        return null
    }

    // first attempt
    if (placeId) return {placeId}
    if (geoLocation) return {geoLocation}
    if (zipCode) return {zipCode}
    return null
}

function patrimonyFilter(contact) {
    return (patrimony) => {
        return !!contact.linkedWith.find((l) => l.patrimony && (l.patrimony.uid == patrimony.uid))
    }
}

class PatrimonyPicker extends Component {
    static propTypes = {
        contact: PropTypes.object,
        company: PropTypes.object,
        zipCode: PropTypes.string,
        placeId: PropTypes.string,
        geoLocation: PropTypes.object
    }

    constructor(props) {
        super(props)

        this.state = {
            filteredStream: []
        }
    }

    componentWillMount() {
        const {dispatch, company, zipCode, placeId, geoLocation} = this.props

        const geoLoc = geoLocationCriteria(zipCode, placeId, geoLocation)

        dispatch(resetMinorCriteria())
        dispatch(queryPatrimonyStream({...DEFAULT_PATRIMONY_QUERY, ...geoLoc, companyUid: company && company.uid, range: {offset: 0, limit: 99}})).then((action) => {
            const geoLoc = geoLocationCriteria(zipCode, placeId, geoLocation, action)
            return geoLoc && dispatch(queryPatrimonyStream({...DEFAULT_PATRIMONY_QUERY, ...geoLoc, companyUid: company && company.uid, range: {offset: 0, limit: 99}}))
        })
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.company && nextProps.company.uid) != (this.props.company && this.props.company.uid)
            || nextProps.zipCode != this.props.zipCode
            || nextProps.placeId != this.props.placeId
            || nextProps.geoLocation != this.props.geoLocation) {
            const {dispatch, company, zipCode, placeId, geoLocation} = nextProps

            const geoLoc = geoLocationCriteria(zipCode, placeId, geoLocation)

            dispatch(resetMinorCriteria())
            dispatch(queryPatrimonyStream({...DEFAULT_PATRIMONY_QUERY, ...geoLoc, companyUid: company && company.uid, range: {offset: 0, limit: 99}})).then((action) => {
                const geoLoc = geoLocationCriteria(zipCode, placeId, geoLocation, action)
                return geoLoc && dispatch(queryPatrimonyStream({...DEFAULT_PATRIMONY_QUERY, ...geoLoc, companyUid: company && company.uid, range: {offset: 0, limit: 99}}))
            })
        }

        if (nextProps.stream != this.props.stream
            || nextProps.contact != this.props.contact) {
            const {stream, contact, placeId, value, onChange, multi} = nextProps

            const filteredStream = contact && stream.filter(patrimonyFilter(contact)) || stream
            this.setState({filteredStream})

            if (!multi) {
                // auto pick single patrimony
                const autoPick = !value && filteredStream.length == 1
                const autoPickByPlaceId = autoPick && placeId && filteredStream[0].addresses.concat(filteredStream[0].complementaryAddresses).find((a) => a.checker && a.checker.googlePlaceId == placeId)
                const autoPickByContact = autoPick && contact && contact.linkedWith.find((l) => l.patrimony && (l.patrimony.uid == filteredStream[0].uid))

                if (autoPickByPlaceId || autoPickByContact) {
                    onChange(filteredStream[0])
                }
            }
        }
    }

    _search(event) {
        const {dispatch, minorCriteria} = this.props

        event.preventDefault()
        dispatch(queryPatrimonyStream(minorCriteria))
    }

    _searchOnKeyPress(event) {
        if (event.key == 'Enter') {
            const {dispatch, minorCriteria} = this.props
            dispatch(queryPatrimonyStream(minorCriteria))
        }
    }

    _clear(event) {
        const {dispatch, minorCriteria} = this.props

        event.preventDefault()
        dispatch(updateMinorCriteria({fullText: null}))
        dispatch(queryPatrimonyStream({...minorCriteria, fullText: null}))
    }

    render() {
        const {dispatch, form, minorCriteria, stream, aggregations, range, query, contact, company, zipCode, placeId, geoLocation, ...others} = this.props
        const {filteredStream} = this.state

        const searched = minorCriteria && minorCriteria.fullText && minorCriteria.fullText == (query && query.fullText)

        const agencySource = matcher({
            source: aggregations && aggregations.agencies || [],
            identify: (a) => a.label
        })

        const afterPatrimonies = () => {
            if (range && (range.limit < range.count - 1)) {
                const count = range.limit + 1
                return (
                    <p>{replace(i18n.useSearchPatrimonyFilters, {count})}</p>
                )
            }
        }

        return (
            <div className={style.default}>
                <Picker
                    source={filteredStream}
                    identify={(p) => p.uid}
                    display={(p) => p.ref + ' - ' + p.label}
                    after={afterPatrimonies()}
                    {...others}>
                    <div>
                        <div className={style.search}>
                            {searched && (
                                <a
                                    href=''
                                    onClick={(e) => this._clear(e)}>
                                    <Icon icon='cross' size='xs' />
                                </a>
                            )}
                            {!searched && (
                                <a
                                    href=''
                                    onClick={(e) => this._search(e)}>
                                    <Icon icon='search' size='xs' />
                                </a>
                            )}
                            <div className={style.container}>
                                <input
                                    type='text'
                                    onKeyPress={(e) => this._searchOnKeyPress(e)}
                                    placeholder={i18n.searchPatrimony.xs}
                                    {...form.fullText()} />
                            </div>
                        </div>
                        <TypeaheadBar
                            size='small'
                            source={agencySource}
                            identify={(a) => a.value}
                            display={(a) => a.label + ' (' + a.count + ')'}
                            placeholder={i18n.searchAgency.xs}
                            {...form.agencyUids()} />
                    </div>
                </Picker>
            </div>
        )
    }
}

PatrimonyPicker = connectLoadingLock()(PatrimonyPicker)

PatrimonyPicker = connectForm({
    target: 'minorCriteria',
    schema: Criteria.schema,
    action: MINOR_CRITERIA_UPDATED
})(PatrimonyPicker)

PatrimonyPicker = connect((state) => ({
    loading: state.loading,
    minorCriteria: state.patrimony.minorCriteria,
    stream: state.patrimony.stream,
    aggregations: state.patrimony.aggregations,
    range: state.patrimony.range,
    query: state.patrimony.query
}))(PatrimonyPicker)

export default PatrimonyPicker


// WEBPACK FOOTER //
// ./lib/patrimony/components/PatrimonyPicker.js